<template>
  <div class="report-box">
    <el-dialog class="dialog dialoga1" title=" " :visible.sync="sucDialogVisible" width="350px" :modal="false">
      <!-- <template slot="title">
        <div class="dialog-title">提示</div>
      </template> -->
      <div class="dialog-content">
        <div class="dialog-content-icon-box">
          <i class="dialog-content-icon el-icon-success" style="font-size:50px"></i>
        </div>
        <div style="font-size:14px;color:rgba(51, 51, 51, 1);padding-top:4px;line-height: 20px;padding-bottom:8px">
          <div>上报成功</div>
          <div>该企业数据录入中，请稍后再试</div>
        </div>

        <!-- <div class="tip">上报成功，该企业数据录入中，请稍后再试</div> -->
        <div class="prompt bg-1" style="color: #666666;font-size:12px">数据录入所需时长为5分钟</div>
        <div style="padding-top:24px">
          <el-button type="dialog-confirm" size="small" w88  @click="sucDialogVisible = false">好的</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="dialog dialoga1" :visible.sync="errDialogVisible" width="350px" :modal="false">
      <!-- <template slot="title">
        <div class="dialog-title">提示</div>
      </template> -->
      <div class="dialog-content">
        <div class="dialog-content-icon-box">
          <i class="dialog-content-icon el-icon-warning" style="font-size:50px;color:RGBA(237, 104, 38, 1)"></i>
        </div>
        <div style="font-size:14px;color:rgba(51, 51, 51, 1);padding-top:4px;line-height: 20px;padding-bottom:8px">
          <div>该企业已存在</div>
        </div>
        <div style="padding-top:24px">
           <el-button type="dialog-confirm" size="small" w88  @click="errDialogVisible = false">好的</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="dialog added-dialog" :visible.sync="addedDialogVisible" width="400px" :modal="false">
      <template slot="title">
        <div class="dialog-title"><i class="el-icon-success"></i>新增企业数据</div>
      </template>
      <div class="dialog-content">
        <el-row type="flex">
          <el-col class="" style="width: 96px;text-align: right;padding-right: 5px;"><span>您上报的 </span> </el-col>
          <el-col style="flex:1;">
            <div class="company-item" v-for="(item, i) in addedCompanyList" :key="`addedCompanyList-item-${i}`">{{item.companyName}}</div>
          </el-col>
        </el-row>
        <div class="company-tip">企业数据已成功录入， 请再次查询</div>
      </div>
    </el-dialog>
    <el-dialog class="dialog" title="缺失企业名称上报" :visible.sync="visible" width="450px" append-to-body>
      <el-form ref="form" :model="ruleForm" :rules="rules" @submit.native.prevent class="form" label-width="120px" label-position="right">
        <el-form-item label="企业名称:" prop="compony">
          <el-input size="small" v-model.trim="ruleForm.compony" placeholder="请填写企业全称" style="width: 280px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false" style="margin-right: 30px;" w88>取消</el-button>
        <el-button type="primary" :loading="loading" size="small" @click="onReport" w88>上报</el-button>
      </div>
    </el-dialog>
    <el-button v-show="showBtn" class="report-btn" type="text" size="mini" @click="visible = true">没有找到想要的企业?点我试试</el-button>
  </div>
</template>
<script type="text/ecmascript-6">
import { companySubmit, getCompanySubmitResult, updateCompanySubmitStatus } from '../api/index'
const setIntervalImmediately = (func, interval) => {
  func()
  return setInterval(func, interval)
}
export default {
  name: "companyReport",
  components: {},
  props: {
    showBtn: {
      default: true
    }
  },
  data() {
    return {
      visible: false,
      sucDialogVisible: false,
      errDialogVisible: false,
      addedDialogVisible: false,
      loading: false,
      rules: {
        compony: { required: true, message: '企业名称不能为空' }
      },
      reportHistoryList: [],
      addedCompanyList: [],
      ruleForm: {
        compony: ''
      },
      interval: null
    }
  },
  mounted() {
    this.$bus.$on('reportUpdate', this.handleReportUpdate)
  },
  methods: {
    handleReportUpdate() {
      !this.showBtn && this.getCompanySubmitResult() // 全局轮询
    },
    showSucDialog() {
      clearTimeout(this.__sucDialogVisibleTimer)
      this.sucDialogVisible = true
      this.__sucDialogVisibleTimer = setTimeout(() => {
        this.sucDialogVisible = false
      }, 5000)
    },
    showErrDialog() {
      clearTimeout(this.__errDialogVisibleTimer)
      this.errDialogVisible = true
      this.__errDialogVisibleTimer = setTimeout(() => {
        this.errDialogVisible = false
      }, 5000)
    },
    onReport() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        this.visible = false
        const params = {
          companyName: this.ruleForm.compony,
          optType: 1
        }
        const res = await companySubmit(params)
        // const res = { code: 200 }
        this.loading = false
        this.$refs.form.resetFields()
        if (res.code === 200) {
          this.$bus.$emit("reportUpdate")
          this.reportHistoryList.push(params.companyName)
          this.showSucDialog()
        } else if (res.code === 1511) {
          this.showErrDialog()
        }
      })
    },
    getCompanySubmitResult() {
      this.interval && clearInterval(this.interval)
      this.interval = setIntervalImmediately(() => {
        getCompanySubmitResult({}).then(({ code, data = [], message }) => {
          if (code != 200) return
          data = data || []
          const successArr = data.filter(v => v.isUpdated)
          this.addedCompanyList = successArr
          this.addedDialogVisible = !!successArr.length
          // 修改全局轮询延迟
          if (successArr.length) {
            updateCompanySubmitStatus({ updateRecords: successArr.map(({ id }) => ({ id })) })
          }
          if (!data.some(v => v.isUpdated == 0)) {
            this.interval && clearInterval(this.interval)
          }
        }).catch(() => { })
      }, 3e4)
    }
  },
  beforeDestroy() {
    // clearTimeout(window.__submitResultTimer)
    this.$bus.$off('reportUpdate', this.handleReportUpdate)
  }
}
</script>
<style lang="scss" scoped>
.report-box {
  position: relative;
  text-align: center;
  margin-top: 32px;
  margin-bottom: -25px;

  // margin-top: 21px;
  // padding: 21px 0 21px 0;
  z-index: 1999;
}
.report-btn {
  font-size: 13px;
  color: #507afd;
}
.form {
  // width: 400px;
  // margin: 30px auto;
  padding: 24px 0 26px 0;
}
.dialog-footer {
  text-align: center;
}
.dialoga1{
  /deep/ {
    .el-dialog__header {
      background: none;
      background-color: #fff;
    }
  }
}
.dialog {
  /deep/ {
    // .el-dialog__header {
    //   padding: 11px 0 11px 24px;
    //   text-align: left;
    //   height: 42px;
    //   font-size: 14px;
    //   font-weight: 600;
    //   color: #666666;
    //   line-height: 20px;
    //   background: #fbfbfb;
    //   border-radius: 4px 4px 0px 0px;
    //   border-bottom: 0;
    // }
    // .el-dialog__footer {
    //   padding: 15px 0 15px 5px;
    //   border-top: 0;
    //   background: #fbfbfb;
    //   .el-button {
    //     width: 88px;
    //     height: 32px;
    //   }
    // }
    .el-dialog__headerbtn {
      // top: 15px;
      // right: 18px;
      // .el-dialog__close {
      //   font-size: 16px;
      //   color: #666666;
      // }
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .dialog-content {
    padding-top: 22px;
    padding-bottom: 32px;
    // height: 158px;
    text-align: center;
    .dialog-content-icon {
      font-size: 40px;
    }
    .el-icon-success {
      color: #30bf78;
    }
    .el-icon-error {
      color: #ff0000;
    }
    .tip {
      margin-top: 19px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
    }
    .prompt {
      margin-top: 5px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }
}
.added-dialog {
  /deep/ {
    .el-dialog {
      border: 1px solid #caefdc;
    }
    .el-dialog,
    .el-dialog__header {
      padding-left: 0;
      background-color: #edffed;
    }
  }
  .dialog-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 20px;
    .el-icon-success {
      margin: 0 8px;
      font-size: 20px;
      color: #30bf78;
    }
  }
  .dialog-content {
    padding-top: 0;
    padding-bottom: 25px;
    height: auto;
    text-align: left;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
  }
  .company-item {
    padding-right: 24px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .company-tip {
    padding-left: 35px;
  }
}
.bg-1{
  // background: rgba(255, 67, 67, 0.2);
  border-radius: 8px;
  display: inline-block;
  padding: 2px 18px;
  color: #666666;
}
</style>
